import {ulid} from "ulidx";
import ClientModule from "@/helpers/Modules/Single/ClientModule";
import PolicyModule from "@/helpers/Modules/Single/PolicyModule";
import VehicleModule from "@/helpers/Modules/Single/VehicleModule";
import ValidatorModule from "@/helpers/Modules/Single/ValidatorModule";

export default class OsgpoModule {
    static Modal = class {
        static infoBlock(val, clientType) {
            const data = {
                1: ['driver', 'politician'], //Страхователь
                2: ['driver', 'politician', 'entrepreneur'], //Застрахованный
                3: ['driver', 'politician', 'entrepreneur'], //Выгодоприобретатель
            }
            return data[clientType].includes(val)
        }
        static infoCard(val) {
            const data = ['iin', 'person', 'resident', 'class']
            return data.includes(val)
        }
        static isOgpo() {
            return true
        }
    }

    static Policy = class extends PolicyModule {
        static empty(today = false, product) {
            return {
                ip:       null,
                apc:      null,
                insureds: [],
                insurer:  null,
                product:  product,
                vehicle:  [],
                number:   ulid(),
                treaty: {
                    date: today ?? '',
                    term: 12
                },
                calculationDate: null,
                insuredsShow:    true,
                vehicleShow:     true,
                isDrive:         false,
                premium:         null,
                hasPaid:         false,
                hasCalc:         false,
                hasSave:         false,
                clientAddedList: [],
                carAddedList:    [],
                residentRules: {
                    insurer: null,
                    insured: [],
                    vehicle: [],
                },
                residentRulesError: {
                    rule: null,
                    text: null,
                    key:  null
                },
                podftSuccess: true,
                product_type: null
            }
        }
    }

    static Client = class extends ClientModule {
        static empty() {
            return {
                client: {
                    activity_kind_id:    '',
                    accountant:          '',
                    patronymic:          '',
                    birthday:            '',
                    surname:             '',
                    email:               '',
                    name:                '',
                    iin:                 '',
                    economics_sector_id: 10,
                    id:                  null,
                    sex:                 1,
                    phone:               '7',
                    politician:          true
                },
                filter: {
                    resident:   true,
                    person  :   true,
                    verify  :   true,
                },
                isBeneficiaryFilter: {
                    resident:   true,
                    person  :   false,
                    verify  :   true,
                },
                main: {
                    phone: '7',
                    iin  : '',
                },
                location: {
                    country_id: 1,
                    address:    '',
                    street:     '',
                    float:      '',
                    home:       '',
                    code:       0
                },
                document: {
                    verified_at: '',
                    type_id:     null,
                    number:      '',
                    issued:      '',
                    issuer:  '',
                    until:   ''
                }
            }
        }
        static documentType(step) {
            const documentTypes = {
                0: {1: 'Удостоверение личности', 4: 'Вид на жительство иностранца', 8: 'Удостоверение лица без гражданства', 11:'Паспорт гражданина РК', 12:'Иностранный паспорт'},
                1: {1: 'Удостоверение личности', 4: 'Вид на жительство иностранца', 8: 'Удостоверение лица без гражданства', 11:'Паспорт гражданина РК', 12:'Иностранный паспорт'},
                default: {7: 'Свидетельство о государственной регистрации (перерегистрации) юридического лица'}
            };

            return documentTypes[step] || documentTypes.default;
        }
        static fieldsSettings(step) {
            const data = {
                0: { // Резидент Физ
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:true  },
                    birthday:            { required: true,  show: true,  disabled:true  },
                    surname:             { required: true,  show: true,  disabled:true  },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: true,  show: true,  disabled:true  },
                    name:                { required: true,  show: true,  disabled:true  },
                    iin:                 { required: true,  show: true,  disabled:true  },
                    sex:                 { required: true,  show: true,  disabled:true  },
                    // Document
                    type_id:             { required: true,  show: true, disabled:true },
                    issued:              { required: true,  show: true, disabled:true },
                    number:              { required: true,  show: true, disabled:true },
                    issuer:              { required: true,  show: true, disabled:true },
                    until:               { required: true,  show: true, disabled:true },
                    // Address
                    country_id:          { required: true, show: false, disabled:true  },
                    address:             { required: true, show: true,  disabled:false }
                },
                1: { // Нерезидент Физ
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:true  },
                    surname:             { required: true,  show: true,  disabled:true  },
                    email:               { required: true,  show: true,  disabled:false },
                    phone:               { required: false, show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:true  },
                    iin:                 { required: false, show: false, disabled:false },
                    sex:                 { required: true,  show: true,  disabled:true  },
                    // Document
                    type_id:             { required: true,  show: true, disabled:true  },
                    issued:              { required: true,  show: true, disabled:true  },
                    number:              { required: true,  show: true, disabled:true  },
                    issuer:              { required: true,  show: true, disabled:false },
                    until:               { required: false, show: true, disabled:false },
                    // Address
                    country_id:          { required: true,  show: true, disabled:true  },
                    address:             { required: true,  show: true, disabled:false }
                },
                2: { // Резидент Юр
                    economics_sector_id: { required: true,  show: true,  disabled:true  },
                    activity_kind_id:    { required: true,  show: true,  disabled:true  },
                    patronymic:          { required: false, show: false, disabled:false },
                    birthday:            { required: true,  show: true,  disabled:true  },
                    surname:             { required: false, show: false, disabled:false },
                    email:               { required: true,  show: true,  disabled:false },
                    phone:               { required: false, show: false, disabled:false },
                    name:                { required: true,  show: true,  disabled:true  },
                    iin:                 { required: true,  show: true,  disabled:true  },
                    sex:                 { required: false, show: false, disabled:false },
                    // Document
                    type_id:             { required: false, show: false, disabled:false },
                    issued:              { required: false, show: false, disabled:false },
                    number:              { required: false, show: false, disabled:false },
                    issuer:              { required: false, show: false, disabled:false },
                    until:               { required: false, show: false, disabled:false },
                    // Address
                    country_id:          { required: false, show: false, disabled:false },
                    address:             { required: true,  show: true,  disabled:false }
                },
                3: { // Нерезидент Юр
                    economics_sector_id: { required: true,  show: true,  disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: false, disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: false, show: false, disabled:false },
                    email:               { required: true,  show: true,  disabled:false },
                    phone:               { required: false, show: false, disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: false, show: false, disabled:false },
                    sex:                 { required: false, show: false, disabled:false },
                    // Document
                    type_id:             { required: false, show: false, disabled:false },
                    issued:              { required: false, show: false, disabled:false },
                    number:              { required: false, show: false, disabled:false },
                    issuer:              { required: false, show: false, disabled:false },
                    until:               { required: false, show: false, disabled:false },
                    // Address
                    country_id:          { required: true, show: true, disabled:false },
                    address:             { required: true, show: true, disabled:false }
                },
                4: { // Лидер резидент
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: true,  show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: true,  show: true,  disabled:false },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: false, show: false, disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                },
                5: { // Лидер нерезидент
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: false, show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: false, show: true,  disabled:false },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: true,  show: true,  disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                },
                6: { // Собственник резидент
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: true,  show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: true,  show: true,  disabled:false },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: false, show: false, disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                },
                7: { // Собственник нерезидент
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: false, show: true,  disabled:false },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: false, show: true,  disabled:false },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: true,  show: true,  disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                },
                8: { // allow all
                    economics_sector_id: { required: false, show: false, disabled:false },
                    activity_kind_id:    { required: false, show: false, disabled:false },
                    patronymic:          { required: false, show: true,  disabled:false },
                    birthday:            { required: true,  show: true,  disabled:false },
                    surname:             { required: true,  show: true,  disabled:false },
                    email:               { required: false, show: true,  disabled:false },
                    phone:               { required: false, show: true,  disabled:true  },
                    name:                { required: true,  show: true,  disabled:false },
                    iin:                 { required: false, show: true,  disabled:true  },
                    sex:                 { required: true,  show: true,  disabled:false },
                    // Document
                    type_id:             { required: true,  show: true,  disabled:false },
                    issued:              { required: true,  show: true,  disabled:false },
                    number:              { required: true,  show: true,  disabled:false },
                    issuer:              { required: true,  show: true,  disabled:false },
                    until:               { required: false, show: true,  disabled:false },
                    // Address
                    country_id:          { required: true,  show: false, disabled:false },
                    address:             { required: false, show: true,  disabled:false }
                }
            }

            return data[step]
        }
        static modalFilterSettings(step) {
            const data = {
                0: {// default
                    person:         { value: true, disabled: true },
                    resident:       { value: true, disabled: true },
                    verify:         { value: true, disabled: true },
                },
                1: {// Страхователь
                    person:         { value: true, disabled: false },
                    resident:       { value: true, disabled: false },
                    verify:         { value: true, disabled: false },
                },
                2: { // Застрахованный
                    person:         { value: true, disabled: false },
                    resident:       { value: true, disabled: false },
                    verify:         { value: true, disabled: false },
                },
                3: { // Выгодоприобретатель
                    person:         { value: false, disabled: true },
                    resident:       { value: true,  disabled: true },
                    verify:         { value: true,  disabled: true },
                },
                4: { // Владелец
                    person:         { value: true, disabled: true  },
                    resident:       { value: true, disabled: false },
                    verify:         { value: true, disabled: false },
                },
                5: { // Лидер
                    person:         { value: true, disabled: true  },
                    resident:       { value: true, disabled: false },
                    verify:         { value: true, disabled: false },
                }
            }

            return data[step]
        }
        static filterByProductType(productType, clientType = 1) {
            if (![1,2].includes(clientType)) clientType = 1
            const data = {
                1: {
                    1: {// ОГПО
                        person:         { value: true, disabled: false },
                        resident:       { value: true, disabled: false },
                        verify:         { value: true, disabled: false },
                    },
                    2: { // ВВ
                        person:         { value: true,  disabled: false },
                        resident:       { value: false, disabled: true },
                        verify:         { value: false, disabled: true },
                    },
                    3: { // Транзит
                        person:         { value: true,  disabled: false },
                        resident:       { value: true,  disabled: true  },
                        verify:         { value: true,  disabled: false },
                    },
                },
                2: {
                    1: {// ОГПО
                        person:         { value: true, disabled: false },
                        resident:       { value: true, disabled: false },
                        verify:         { value: true, disabled: false },
                    },
                    2: { // ВВ
                        person:         { value: true,  disabled: false },
                        resident:       { value: false, disabled: true },
                        verify:         { value: false, disabled: true },
                    },
                    3: { // Транзит
                        person:         { value: true,  disabled: false },
                        resident:       { value: true,  disabled: false  },
                        verify:         { value: true,  disabled: false },
                    },
                }
            }

            return data[clientType][productType]
        }
        static recalculateDisabledFields(fieldSettings, data) {
            if (!data.document || data.document.number === null || data.document.number === '' || data.document.number === undefined) return fieldSettings
            let formatedData = this.flattenToValues(data)
            const allowedFields = ['issued', 'sex', 'until', 'issuer', 'address', 'email', 'country_id']
            Object.keys(fieldSettings).forEach(key => {
                if (!allowedFields.includes(key)) return
                if (formatedData[key] === null || formatedData[key] === '' || formatedData[key] === undefined) {
                    fieldSettings[key].disabled = false
                }
            })
            return fieldSettings
        }
    };

    static Vehicle = class extends VehicleModule {
        static empty() {
            return {
                id:        0,
                type_id:   4,
                number:    '',
                vin:       '',
                body:      '',
                chassis:   '',
                year:      '',
                color:     '',
                places:    '',
                category:  '',
                mark_id:   '',
                mark:      '',
                model_id:  '',
                model:     '',
                engine: {
                    number:  '',
                    power:   '',
                    volume:  ''
                },
                registration: {
                    number:      '',
                    certificate: '',
                    date:        '',
                    region_id:   '',
                    big_city:    '',
                    kato:        ''
                },
                verify:      true
            }
        }
        static searchValues(verify) {
            if (verify) return {number:null, certificate:null}
            return {vin:null, certificate:null}
        }
        static fieldsSettings(step) {
            const data = {
                0: {// Simple auto резидент
                    number:        { required: true, show: true, disabled: true  },
                    vin:           { required: true, show: true, disabled: true  },
                    type_id:       { required: true, show: true, disabled: false },
                    year:          { required: true, show: true, disabled: false },
                    mark:          { required: true, show: true, disabled: false },
                    model:         { required: true, show: true, disabled: false },
                    color:         { required: false,show: true, disabled: false },
                    places:        { required: false,show: true, disabled: false },
                    category:      { required: false,show: true, disabled: false },
                    body:          { required: false,show: true, disabled: false },
                    chassis:       { required: false,show: true, disabled: false },
                    engine: {
                        number:        { required: false,show: true, disabled: false },
                        power:         { required: false,show: true, disabled: false },
                        volume:        { required: false,show: true, disabled: false },
                    },
                    registration: {
                        number:        { required: true, show: true, disabled: true },
                        certificate:   { required: true, show: true, disabled: true },
                        date:          { required: true, show: true, disabled: true },
                        region_id:     { required: false, show: true, disabled: true },
                    }
                },
                1: { // Simple auto нерезидент
                    number:        { required: true, show: true, disabled: false },
                    vin:           { required: true, show: true, disabled: true  },
                    type_id:       { required: true, show: true, disabled: false },
                    year:          { required: true, show: true, disabled: false },
                    mark:          { required: true, show: true, disabled: false },
                    model:         { required: true, show: true, disabled: false },
                    color:         { required: false,show: true, disabled: false },
                    places:        { required: false,show: true, disabled: false },
                    category:      { required: false,show: true, disabled: false },
                    body:          { required: false,show: true, disabled: false },
                    chassis:       { required: false,show: true, disabled: false },
                    engine: {
                        number:        { required: false,show: true, disabled: false },
                        power:         { required: false,show: true, disabled: false },
                        volume:        { required: false,show: true, disabled: false },
                    },
                    registration: {
                        number:        { required: true, show: true, disabled: false },
                        certificate:   { required: true, show: true, disabled: false },
                        date:          { required: true, show: true, disabled: false },
                        region_id:     { required: false,show: true, disabled: true  },
                    }
                }
            }
            return data[step]
        }
    };

    static Validator = class extends ValidatorModule {
        static formMain(step, form) {
            switch (true) {
                case (step === 0):
                    return form.phone.length === 16 && (form.iin.length === 15)
                case (step === 2):
                    return form.iin.length === 15
                case (step === 1):
                    return  form.document.length > 5
                case (step === 3):
                    return form.name.length > 3
            }
        }
        static uploadImages(policy) {
            if (!policy.insurer || !policy.insureds || !policy.vehicle) {
                return false
            }
            if (!policy.insurer.filter.resident && policy.insurer.filter.person) {
                let uniqueTypeIds = policy.insurer.hasOwnProperty('images') ? new Set(policy.insurer.images.map(item => item.type_id)) : new Set();
                let insurerImagesCount = uniqueTypeIds.size
                if (policy.insurer.driver.pensioner ? insurerImagesCount !== 3 : insurerImagesCount !== 2) {
                    return false
                }
            }

            for (let insured of policy.insureds) {
                if (!insured.filter.resident && policy.insurer.filter.person) {
                    let uniqueTypeIds = insured.hasOwnProperty('images') ? new Set(insured.images.map(item => item.type_id)) : new Set();
                    let insuredImagesCount = uniqueTypeIds.size
                    if (insured.driver.pensioner ? insuredImagesCount !== 3 : insuredImagesCount !== 2) {
                        return false
                    }
                }
            }

            for (let vehicle of policy.vehicle) {
                if (!vehicle.verify) {
                    let uniqueTypeIds = vehicle.hasOwnProperty('images') ? new Set(vehicle.images.map(item => item.type_id)) : new Set();
                    let vehicleImagesCount = uniqueTypeIds.size
                    if (vehicleImagesCount !== 1) {
                        return false
                    }
                }
            }
            return true
        }
        static objectKeyToKey(data, list) {
            if (data && list) {
                let val = []
                let arr = []
                Object.keys(data).forEach(key => {val.push(`${key}`)});
                list.forEach(item => {arr.push(val.includes(item))})
                return arr.every((elem) => elem >= true)
            }
        }
        static validateField(data, settings) {
            // eslint-disable-next-line no-prototype-builtins
            if (settings.hasOwnProperty('required')) {
                return !settings.required || !!data;
            } else {
                return Object.entries(settings).every(([field, properties]) => {
                    return !properties.required || !!data[field];
                });
            }
        }
        static mainByFilterStep(step, form) {
            const steps = {
                0: ['phone', 'name', 'surname', 'birthday', 'sex', 'iin'],
                1: ['phone', 'name', 'surname', 'birthday', 'sex'],
                2: ['economics_sector_id', 'activity_kind_id', 'chief', 'accountant', 'name', 'iin'],
                3: ['economics_sector_id', 'activity_kind_id', 'chief', 'accountant', 'name']
            };

            const stepKeys = steps[step] || [];
            return stepKeys.every(key => {
                const value = form[key];
                if (key === 'phone') return value?.length === 16;
                if (key === 'iin') return value?.length === 12;
                return Boolean(value);
            });
        }
        static getResidentRulesMatrix(productType = null) {
            const rules = {
                1: [
                    [1, 1, 1],  //Резидент,   Резидент,   Резидент
                    [1, 0, 1],  //Резидент,   Нерезидент, Резидент
                    [0, 1, 1],  //Нерезидент, Резидент,   Резидент
                    [0, 0, 1],  //Нерезидент, Нерезидент, Резидент
                    [1, 2, 1],  //Резидент,   Микс, Резидент
                    [0, 2, 1],  //Нерезидент, Микс, Резидент
                ],
                2: [
                    [0, 0, 0], //Нерезидент, Нерезидент, Нерезидент
                ],
                3: [
                    [1, 1, 0], //Резидент,   Резидент,   Нерезидент
                    [1, 0, 0], //Резидент,   Нерезидент, Нерезидент
                    [1, 2, 0], //Резидент,   Микс,       Нерезидент
                ]
            };
            return productType ? rules[productType] : rules;
        }
        static checkResidentRules(data, productType, hasWayBill = null) {
            if (data.insurer !== null && data.insured.length && data.vehicle.length) {
                let info = productType === 1 ? 'Оформление невозможно: машина не зарегистрированна в РК' : 'Оформление невозможно: в полисе присутствует резидент';
                const validate = this.getResidentRulesMatrix(productType);
                if (validate) {
                    validate.forEach((item) => {
                        let temp = [-1, -1, -1];
                        let dataArr = [[data.insurer], data.insured, data.vehicle];
                        if (hasWayBill !== null && hasWayBill !== undefined && productType === 2) dataArr[1][hasWayBill] = !!item[1]
                        for (let i = 0; i < dataArr.length; i++) {
                            if (item[i] === 0 && dataArr[i].every((e) => e === false)) temp[i] = item[i];
                            if (item[i] === 1 && dataArr[i].every((e) => e === true)) temp[i] = item[i];
                            if (item[i] === 2 && dataArr[i].some((e) => e !== dataArr[i][0])) temp[i] = item[i];
                        }
                        if (JSON.stringify(item) === JSON.stringify(temp)) {
                            info = null;
                        }
                    });
                }
                return info;
            }
        }
        static checkResidentRulesSingle(verifyParam, productType, itemType) {
            const rules = this.getResidentRulesMatrix(productType);
            const products = ['"ОГПО ВТС Стандарт"', '"ОГПО ВТС Временный въезд"', '"ОГПО ВТС Транзит"']
            const info = [
                ['Страхователь не может быть нерезидентом для ','Страхователь не может резидентом для '],                   //insurer errors
                ['Застрахованный не может быть нерезидентом для ','Застрахованный не может резидентом для '],               //insured errors
                ['Иностранная регистрация ТС не допускается для ','Авто с казахстанской регистрацией не допускается для ']  //vehicle errors
            ]
            if (rules) {
                const column = rules.map(item => item[itemType-1]);
               if (column.some(item => item === Number(verifyParam))) {
                   return null
               }
               return info[itemType - 1][Number(verifyParam)] + products[productType - 1]
            }
            return 'Неверный тип продукта'
        }
        static insuredsVehiclesShow(insureds, vehicle) {
            let data = [];
            switch (true) {
                case (vehicle <= 1 && insureds <= 1):
                    data['insuredsShow'] = true
                    data['vehicleShow'] = true
                    break
                case (vehicle === 1 && insureds > 11):
                    data['insuredsShow'] = false
                    data['vehicleShow'] = false
                    break
                case (insureds === 1 && vehicle > 11):
                    data['vehicleShow'] = false
                    data['insuredsShow'] = false
                    break
                case (vehicle > 11 && insureds === 0):
                    data['vehicleShow'] = false
                    data['insuredsShow'] = true
                    break
                case (insureds > 11 && vehicle === 0):
                    data['insuredsShow'] = false
                    data['vehicleShow'] = true
                    break
                case (vehicle < 12 && insureds === 1):
                    data['insuredsShow'] = false
                    data['vehicleShow'] = true
                    break
                case (insureds < 12 && vehicle === 1):
                    data['vehicleShow'] = false
                    data['insuredsShow'] = true
                    break
                default:
                    data['insuredsShow'] = true
                    data['vehicleShow'] = true
                    break
            }

            return data
        }
        static vehicleByRequiredFields(info, step = 0) {
            if (!info || !Array.isArray(info)) {
                if (Object.keys(info).length > 0) {
                    info = Object.values(info)
                } else {
                    return false
                }
            }
            let settings = OsgpoModule.Vehicle.fieldsSettings(step);
            for (let item of info) {
                for (let key in settings) {
                    if (key in item) {
                        let check = this.validateField(item[key], settings[key])
                        if (!check) {
                            return false
                        }
                    } else {
                        return false
                    }
                }
            }
            return true
        }
        static clientByInfoAndSearchStep(step, clientInfo) {
            const lists = {
                1: ['client', 'filter'],
                2: ['client', 'filter', 'driver', 'document', 'location']
            }

            return this.objectKeyToKey(clientInfo, lists[step])
        }
        static vehicleByInfoAndSearchStep(step, clientInfo) {
            const lists = {
                1: ['engine', 'filter', 'vehicle'],
                2: ['engine', 'filter', 'vehicle', 'registration']
            }

            return this.objectKeyToKey(clientInfo, lists[step])
        }
        static driversLicense(policy) {
            if (!policy.insurer || !policy.insureds) {
                return false
            }
            for (let insured of policy.insureds) {
                if (insured.filter.person) {
                    if (!insured.hasOwnProperty('driver') || !insured.driver.hasOwnProperty('document') || !insured.driver.document
                        || !insured.driver.document.hasOwnProperty('number') || !insured.driver.document.hasOwnProperty('issued')
                        || !insured.driver.document.number || !insured.driver.document.issued) {
                        return false
                    }
                }
            }
            return true
        }
        static insurerLegalDocument(insurer) {
            if (insurer.hasOwnProperty('images') && insurer.images.length) {
                if (!insurer) return false
                if (!insurer.leader) return false
                if (!insurer.beneficiaries.length) return false
                if (!insurer.filter.resident && !insurer.filter.person) {
                    if (insurer.images.find(item => item.temp_id === 555) === undefined) return false //'Удостоверение/Паспорт руководителя или иного должностного лица'
                    if (insurer.images.find(item => item.temp_id === 666) === undefined) return false //'Приказ/Доверенность на право подписи'
                    if (insurer.images.find(item => item.temp_id === 777) === undefined) return false //'Свидетельство/Справка о гос. Регистрации (документ, выданный уполномоченным органом, подтверждающий факт прохождения гос. Регистрации)'
                    if (insurer.images.find(item => item.temp_id === 888) === undefined) return false //'Устав/Положение (или выписка из реестра держателей ценных бумаг)'
                }
                if (!insurer.leader.resident) {
                    if (insurer.images.find(item => item.temp_id === 111) === undefined) return false //Международный паспорт
                    //Миграционная карта/visa if (insurer.images.find(item => item.temp_id === 222) === undefined) return false
                }
                if (insurer.beneficiaries.length) {
                    let flag = true
                    insurer.beneficiaries.forEach((item, key) => {
                        if (!item.resident) {
                            if (insurer.images.find(i => i.temp_id === 111+(key+1)) === undefined) flag = false //Международный паспорт
                            //Миграционная карта/visa if (insurer.images.find(i => i.temp_id === 222+(key+1)) === undefined) flag = false
                        }
                    })
                    if (!flag) return flag
                }
                return true
            } else return !insurer.person && insurer.resident;
        }
        static validateClient(data) {
            if (!data || data.client === undefined) return {result: false, message: ''}
            const checks = [
                this.validateFill([data]),
            ]
            if (checks.every((item) => item.result)) {
                return {result: true}
            } else {
                return {result: false, message: checks.find((item) => !item.result).message}
            }
        }
        static validateNameSurname(str) {
            const latinRegex = /[A-Za-z]/;
            const cyrillicRegex = /[А-Яа-яЁёӘәҒғҚқҢңӨөҰұҮүҺһІі]/;
            let firstLang = null;
            for (let i = 0; i < str.length; i++) {
                const char = str[i];
                if (!firstLang && (latinRegex.test(char) || cyrillicRegex.test(char))) {
                    firstLang = latinRegex.test(char) ? "latin" : "cyrillic";
                }
                if (latinRegex.test(char) || cyrillicRegex.test(char)) {
                    if (
                        (firstLang === "latin" && cyrillicRegex.test(char)) ||
                        (firstLang === "cyrillic" && latinRegex.test(char))
                    ) {
                        return {
                            result: false,
                            message: `Недопустимый символ в <b>${str}</b> → "${char}" <br/> Строка должна содержать только ${firstLang === "latin" ? "латиницу" : "кириллицу (включая казахский алфавит)"} <br/> Необходимо сделать распознавание  паспорта еще раз.`
                        };
                    }
                } else if (char === "1" || char === "-" || char === " ") {
                    continue;
                } else {
                    if (/[0-9]/.test(char)) {
                        return {
                            result: false,
                            message: `Недопустимый символ в <b>${str}</b> "${char}" <br/> Разрешена только цифра 1 <br/> Необходимо сделать распознавание  паспорта еще раз.`
                        };
                    } else {
                        return {
                            result: false,
                            message: `Недопустимый символ в <b>${str}</b> "${char}" <br/> Запрещённый символ <br/>  Необходимо сделать распознавание  паспорта еще раз.`
                        };
                    }
                }
            }

            return { result: true, message: '' };
        }
        static validateFill(data) {
            if (!Array.isArray(data)) {
                data = Object.values(data);
            }
            for (let item of data) {
                if (!item || JSON.stringify(item) === '{}') { continue; }
                let filterStep    = OsgpoModule.Client.filterStep(item.filter)
                let fieldSettings   = OsgpoModule.Client.fieldsSettings(filterStep)
                if (!this.validateFields(OsgpoModule.Client.flattenToValues(item), fieldSettings)) {
                    return {result: false, message: 'Пожалуйста, заполните все обязательные поля, чтобы продолжить.'}
                }
                if (!item.filter.resident) {
                    if (!this.validateNameSurname(item.client.name).result || !this.validateNameSurname(item.client.surname).result) {
                        return !this.validateNameSurname(item.client.name).result
                            ? this.validateNameSurname(item.client.name)
                            : this.validateNameSurname(item.client.surname)
                    }
                }
            }
            return {result: true}
        }
        static validateFields(data, settings) {
            if (typeof settings !== 'object' || settings === null || typeof data !== 'object' || data === null) {
                return false;
            }
            return Object.entries(settings).every(([field, properties]) => {
                if (!properties.required) return true
                const value = data[field]
                return value !== null && value !== undefined && value !== ''
            });
        }
        static validateVehicleRegistration(data) {
            if (!data || typeof data !== 'object' || !data.registration) {
                return false;
            }
            if (!data.verify) return true
            const registrationFields = [
                "number",
                "certificate",
                "date",
                "region_id",
                "big_city",
            ];
            for (let field of registrationFields) {
                if (data.registration[field] === null || data.registration[field] === undefined || data.registration[field] === '') {
                    return false;
                }
            }
            return true;
        }
    }

    static test() {
        console.log('test');
    }
}
